var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVoicemail = function SvgVoicemail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.6 9.5",
    style: {
      enableBackground: "new 0 0 23.6 9.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.9,0c-2.6,0-4.7,2.1-4.7,4.7c0,1,0.3,2,0.9,2.8l0.2,0.3H8.4l0.2-0.3c0.6-0.8,0.9-1.8,0.9-2.8 C9.5,2.1,7.4,0,4.7,0S0,2.1,0,4.7c0,2.6,2.1,4.7,4.7,4.7h14.1c2.6,0,4.7-2.1,4.7-4.7C23.6,2.1,21.5,0,18.9,0z M4.7,7.8 C3,7.8,1.6,6.5,1.6,4.7S3,1.6,4.7,1.6S7.8,3,7.8,4.7S6.5,7.8,4.7,7.8z M18.9,7.8c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1 C20.6,1.6,22,3,22,4.7S20.6,7.8,18.9,7.8z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVoicemail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/voicemail.459a1e19.svg";
export { ForwardRef as ReactComponent };